<!-- HANDLES SPECIFIC MENU TYPES -->

<template>
  <ul v-bind:class="{ 'nav nav-pills nav-stacked': !issub, 'nav-sub': issub }"
     v-bind:style="{ display: (!dropDownOpen&&issub)?'none':'block'}">
    <slot name="item" v-for="item in items">
      
      <!-- ACTIONS -->
      <li v-if="item.actions && visEval(item.visible)"
          :class="item.styleClasses"
      >
        <a
          href="#"
          :title="item.label"
          v-on:click.prevent="action(item.actions)"
        >
          <i :class="item.icon"></i> {{ item.label }}</a>
      </li>

      <!-- REGULAR NAVITEM -->
      <router-link
        v-else-if="item.path && visEval(item.visible)"
        tag="li"
        :to="item.path"
        :exact="item.exact"
        :title="item.label"
        active-class="active"
        :class="item.styleClasses"
        v-on:click.native="closeNavbar()"
      >
        <a><i :class="item.icon"></i> {{ item.label }}</a>
      </router-link>

      <!-- SUBMENU LABEL -->
      <li 
      v-show="item.subs && visEval(item.visible)" 
        class="nav-dropdown" 
        
       :class="item.styleClasses + dropDownOpen? ' open':''"
       >
        <a href="#" 
          :title="item.label" 
          v-on:click="toggleDropdown">
          <i :class="item.icon"></i> {{ item.label }}
        </a>
        <!--SUBS-->
        <nav-bar-item 
        
          :class="item.styleClasses"
          :items="item.subs" 
          :issub="true"
          :dropDownOpen="false"
          >
          <template slot="item" slot-scope="props"> </template>
        </nav-bar-item>
      </li>

      <!--HTML-->
      <li v-show="item.html && visEval(item.visible)"
         :class="item.styleClasses"
         >
          <html-renderer-old
            :template="item.html" 
            :app="$store.state.site.content.app" 
          >
          </html-renderer-old>
      </li>
      
      
    </slot>
  </ul>
</template>

<script>
import { EventBus } from "Js/eventBus";

export default {
  name: "nav-bar-item",
  
  methods: { //Accepts an action array or a single named array
    action: function(actionsOrNamed) {
      this.closeNavbar()
      //  if named then call named else call regular
      if (actionsOrNamed.name) {
        //   Object.assign(actionsOrNamed.options, {item:item} )
        EventBus.$emit("processNamedAction", actionsOrNamed);
      }
      else {
        // action can be single or array
        var actionsArray = [];
        if (actionsOrNamed.constructor === Array) {
          actionsArray = actionsOrNamed;
        }
        else {
          actionsArray.push(actionsOrNamed);
        }
  
        EventBus.$emit("processActions", actionsArray);
      }
    },
  
    visEval: function(func) {
      return typeof func === "function" ? func() : func != null ? func : 1;
    },
  
    // if navbar opan and should be closed after click
    // if < 768 close bar
    closeNavbar: function() {
      this.$store.commit("SET_SIDEBAROPEN", !this.$store.state.site.sidebarOpen)
    },
    
    toggleDropdown: function() {
      this.dropDownOpen = ! this.dropDownOpen
    },
  },

  props: ["items", "issub"],

  mounted() {},

  data() {
    return {
      dropDownOpen: false
    };
  }
};
</script>

<style></style>
